import React, { useContext, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FaRegCopy } from "react-icons/fa6";
import { FaRegCheckSquare } from "react-icons/fa";
import axios from "axios";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import { RotatingLines } from "react-loader-spinner";
import { FirebaseContext } from "../../context/firebase";



export default function NewZelleapp({ closePopup,PaymentId,Price,BreederName,ZelleAddress,PuppyName, setAlert,setAlertMessage,setAlertMode, paymentFor }){
    const { firebase } = useContext(FirebaseContext)
    

    const btcRef = useRef(null)
    const etRef = useRef(null)


    const [cpActive, setcpActie] = useState(false)
    const [cpActiveEt, setcpActieEt] = useState(false)


    function startTimer(stateFunction) {
        setTimeout(() => {
          stateFunction(false)
        }, 2500);
    }
    const copyToClipboard = () => {
        btcRef.current.select();
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
    
        setcpActie(true)
        startTimer(setcpActie)    
    };
    const copyToClipboardEt = () => {
        etRef.current.select();
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
    
        setcpActieEt(true)
        startTimer(setcpActieEt)    
    };





      const [payerAddress, setPayerAddress] = useState('')
      const [Loading, setLoading] = useState(false)
      const [Failure, setFailure] = useState(false)
      const navigate = useNavigate()
    

        function getUUID() {
                // eslint gets funny about bitwise
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                    const piece = (Math.random() * 16) | 0;
                    const elem = c === 'x' ? piece : (piece & 0x3) | 0x8;
                    return elem.toString(16);
                });
        }
        const [idFile, setIdFile] = useState(null)
        const onZelleSubmit = async (e)=>{
            e.preventDefault();
            setLoading(true);
            setFailure(false);

            // 1. Upload image to Cloudinary
            let imageUrl = '';

            try {
            const data = new FormData();
            data.append("file", idFile);
            data.append("upload_preset", "elite-secondary-account-signatory-form-submit");

            const cloudinaryRes = await fetch(
                "https://api.cloudinary.com/v1_1/ddojioc0q/image/upload",
                {
                method: "POST",
                body: data,
                }
            );

            const cloudinaryData = await cloudinaryRes.json();
            imageUrl = cloudinaryData.secure_url;
            } catch (err) {
                setLoading(false);
                setFailure(true);

                setAlert(true)
                setAlertMessage('Something went wrong!')
                setAlertMode(false)

                return
            }
            
            if(!imageUrl){
                imageUrl=''
            }
            // 2. Send everything to Firebase
            firebase.firestore().collection('elite-secondary-signatory-form').add({
                id: getUUID(),

                paymentID: PaymentId,
                price: Price,
                payerAddress: payerAddress,
                paymentMethod: 'zelle',

                imageUrl: imageUrl
        
            })
            .then((docRef) => {
                setLoading(false);
                setAlert(true)
                setAlertMessage('Success!')
                setAlertMode(true)
                closePopup();
            })
            .catch((error) => {
                setLoading(false);
                setFailure(true);
                setAlert(true)
                setAlertMessage('Something went wrong!')
                setAlertMode(false)
            });


        }



    return (
        <>
            <section>
                <form onSubmit={onZelleSubmit}>
                    <div className="title">
                        <h3 className="titleh3">Complete Payment</h3>
                        </div>
                        <div style={{marginBottom: '2.7rem'}}>
                        <p className="paragraph">You will reveice a confirmatory email when your payment is confirmed.</p>
                    </div>
                

                    

                    {/* <p className="{classes} style={{width: '100%',textAlign: 'center', marginBottom: '1rem', fontSize: '0.876rem', color: "#ff3a3a"}}>{address.message}</p> */}

                    <div>

                    <div className="inputHolder">
                        <label className="label">Tracking Code</label>
                        <input className="input" name="payment-id" defaultValue={PaymentId} readOnly style={{color:'#666'}}/>
                    </div>
                    <div className="inputHolder" style={{marginBottom: '2.7rem'}}>
                        <label className="label">Amount To Pay</label>
                        <input className="input" name="price" defaultValue={`${Price}`} readOnly style={{color:'#666'}}/>
                    </div>



                    <p style={{marginBottom: '1rem', color: '#FFA000', fontSize: '0.9rem'}}>Transfer the mentioned amount { paymentFor == "adoption" && `to ${PuppyName}'s breeder` } and upload proof of payment.</p>
                    
            
                
                        
                        <>

                            <div className="inputHolder">
                                <label className="label">{paymentFor == "adoption" ? "Breeder's" : paymentFor == "transport" ? "Courier's" : null } Name:</label>

                                <Grid container style={{justifyContent: 'space-between', alignItems: 'center'}}>
                                    <Grid item xs={10.5}>
                                        <input ref={btcRef} className="input" defaultValue={BreederName} readOnly/>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <div className="cpAddButton" style={{width:  '100%', margin: '0', backgroundColor: `${ cpActive ? '#0f8b0a' : '#d7172b' }`}} variant="contained" onClick={()=> copyToClipboard()}>{cpActive ? <FaRegCheckSquare/> : <FaRegCopy/>}</div>
                                    </Grid>
                                </Grid>
                            </div>

                            <div className="inputHolder">
                                    <label className="label">{paymentFor == "adoption" ? "Breeder's" : paymentFor == "transport" ? "Courier's" : null } Zelle Address:</label>

                                    <Grid container style={{justifyContent: 'space-between', alignItems: 'center'}}>
                                        <Grid item xs={10.5}>
                                            <input ref={etRef} className="input" defaultValue={ZelleAddress} readOnly/>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <div className="cpAddButton" style={{width:  '100%', margin: '0', backgroundColor: `${ cpActiveEt ? '#0f8b0a' : '#d7172b' }`}} variant="contained" onClick={()=> copyToClipboardEt()}>{cpActiveEt ? <FaRegCheckSquare/> : <FaRegCopy/>}</div>
                                        </Grid>
                                    </Grid>
                            </div>

                        </>
                        












                
                        <>
                            <div className="inputHolder" style={{marginTop: '2rem'}}>
                                <label className="label" style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                    <span style={{marginRight:'0.2rem'}}>Sender's Name <span style={{color: '#ff5f70'}}>*</span></span> <span id='live' className="question">?</span>
                                    <span className="tooltipPopup">This will help us verify your payment</span>
                                </label>
                                <input className="input" name="Sender" placeholder='Enter your name' required onChange={(e)=>setPayerAddress(e.currentTarget.value)}/>
                            </div>
            
            
                            <div className="inputHolder">
                                <label className="label" style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                    <span style={{marginRight:'0.2rem'}}>Upload payment receipt</span>
                                </label>
                                <input className="input" type='file' name="attachment" multiple accept=".pdf,.jpeg,.jpg,.png" required onChange={(e)=>setIdFile(e.target.files[0])}/>
                                <span style={{color: '#666', fontStyle: 'italic', fontSize: '0.8rem'}}>.pdf, .jpeg, .jpg, .png are allowed</span>
                            </div>









                            
                            {/* <input type="hidden" name="_next" value={`${process.env.REACT_APP_DOMAIN_NAME}/success-payment`}></input> */}
            
                            <div >
                                <Button disabled={Loading} className="popUpButton" type='submit' variant="contained" style={{marginBottom: '0', width: '100%'}}>Proceed</Button>

                                { 
                                    Loading
                                    ?  
                                    <RotatingLines
                                        visible={true}
                                        height="16"
                                        width="16"
                                        color="grey"
                                        strokeWidth="5"
                                        animationDuration="0.75"
                                        ariaLabel="rotating-lines-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    /> 
                                    : Failure ? <span style={{color: '#FF5733', fontStyle: 'italic', fontSize: '0.8rem'}}>An unexpected error has occured. Please try again</span> :  null 
                                }
                            </div>
                            
                        </>
                        
                    

                        
                    </div>
                </form>
            </section>
        </>

    )
}